<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      <h1>{{'Filter services' | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        @if (!currentProject) {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Projects' | translate}}</label>
            <app-dropdown
              [(appModel)]="arguments.projects"
              [list]="dropdownLists.projects"
              [value]="'id'"
              [name]="'title'"
              [multiple]="true"
            ></app-dropdown>
          </div>
        }
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Date from' | translate}}</label>
          <input class="centered" [attr.max]="arguments.date_to" type="date" name="date_from" [(ngModel)]="arguments.date_from" placeholder="{{'Insert date' | translate}}">
        </div>
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Date to' | translate}}</label>
          <input class="centered" [attr.min]="arguments.date_from" type="date" name="date_to" [(ngModel)]="arguments.date_to" placeholder="{{'Insert date' | translate}}">
        </div>
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Status' | translate}}</label>
          <app-dropdown
            [(appModel)]="arguments.status"
            [list]="dropdownLists.service_statuses"
            [value]="'id'"
            [backTranslate]="true"
            [name]="'se_st_name'"
            [multiple]="true"
            [showCheckboxOptions]="true"
          ></app-dropdown>
        </div>
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Category' | translate}}</label>
          <app-dropdown
            [(appModel)]="arguments.category"
            [list]="dropdownLists.service_categories"
            [value]="'id'"
            [backTranslate]="true"
            [name]="'category_name'"
            [multiple]="true"
            [showCheckboxOptions]="true"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label>{{'Unit' | translate}}</label>
          <app-dropdown
            [(appModel)]="arguments.units"
            [list]="dropdownLists.units"
            [value]="'id'"
            [name]="'unit_name'"
            [multiple]="true"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label>{{'Vendors' | translate}}</label>
          <app-dropdown
            [(appModel)]="arguments.vendor"
            [list]="dropdownLists.list_vendor"
            [value]="'vendor'"
            [name]="'vendor'"
            [multiple]="true"
            [showCheckboxOptions]="true"
          ></app-dropdown>
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label>{{'Purchase order' | translate}}</label>
          <app-dropdown
            [(appModel)]="arguments.po"
            [list]="dropdownLists.list_po"
            [value]="'po'"
            [name]="'po'"
            [multiple]="true"
            [showCheckboxOptions]="true"
          ></app-dropdown>
        </div>
        <div class="L-12 M-12 S-12 columns">
          <input type="checkbox" name="includeMonthly" [(ngModel)]="arguments.includeMonthly">
          <p class="checkbox">{{'Include monthly services' | translate}}</p>
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Filter' | translate}}">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>
